/**
 * Desktop sidebar tri-state: expanded (full) · rail (56px icons) · hidden (width 0).
 * Persisted under the legacy key so existing preferences migrate without ever
 * rewriting the stored value behind the user's back: a build rollback reading
 * a new value ('rail'/'expanded'/'hidden' ≠ 'true') falls back to expanded — safe.
 */
export type SidebarState = 'expanded' | 'rail' | 'hidden';

export const SIDEBAR_STATE_KEY = 'bigwa-sidebar-collapsed';

/**
 * Maps the raw localStorage value to a SidebarState.
 * Legacy boolean era: 'true' (collapsed) → hidden; 'false' → expanded.
 * Absent or unknown values fail safe to expanded — the sidebar must never
 * vanish because of garbage in storage.
 */
export function parseSidebarState(raw: string | null): SidebarState {
  switch (raw) {
    case 'true':
      return 'hidden';
    case 'expanded':
    case 'rail':
    case 'hidden':
      return raw;
    default:
      return 'expanded';
  }
}
